/**
 * Mantine theme aligned with the MAFA design system. We only customise
 * what's strictly visible in Mantine-rendered components (DataTable,
 * Modal, Notifications, DateInput, MultiSelect). The bulk of the UI is
 * served by the MAFA atomic components (Card, Button, Sidebar, etc.)
 * and inherits its style from global.css.
 */
import { createTheme, type MantineColorsTuple } from '@mantine/core';
import { fonts, radius } from './tokens';

// 10-stop teal scale derived from the accent OKLCH from the MAFA system.
// Mantine asks for hex/rgb, so we approximate; the exact accent shade is
// used at index 6 (the primary one).
const teal: MantineColorsTuple = [
  '#eaf6f4',
  '#d3eae6',
  '#a5d3cc',
  '#75bdb1',
  '#4faa9b',
  '#369d8d',
  '#2a8d7e',
  '#1d7a6c',
  '#0f6859',
  '#005447',
];

// Amber scale for the "alert" semantic.
const amber: MantineColorsTuple = [
  '#fff4e6',
  '#fde0c2',
  '#fbcb9b',
  '#f8b573',
  '#f59e4a',
  '#f48b32',
  '#df751c',
  '#c66312',
  '#b2570b',
  '#8e4204',
];

export const mantineTheme = createTheme({
  fontFamily: fonts.sans,
  fontFamilyMonospace: fonts.mono,
  defaultRadius: 'md',
  radius: {
    xs: radius.sm,
    sm: radius.sm,
    md: '10px',
    lg: radius.lg,
    xl: radius.xl,
  },
  primaryColor: 'teal',
  primaryShade: 6,
  colors: {
    teal,
    amber,
  },
  components: {
    Modal: {
      defaultProps: { radius: 'xl', centered: true, overlayProps: { blur: 2 } },
    },
    Drawer: {
      defaultProps: { radius: 'md', overlayProps: { blur: 2 } },
    },
  },
});
